import { buildTikTokPixelScript, type TikTokPixelConfig } from './resolve';

export const SCRIPT_ID = 'tiktok-pixel-script';

export function injectTikTokPixel(config: TikTokPixelConfig): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.textContent = config.kind === 'id'
    ? buildTikTokPixelScript(config.pixelId)
    : config.body;
  document.head.appendChild(script);
}
